import { render } from "./StatsBlock.vue?vue&type=template&id=f6302844&scoped=true&lang=pug"
import script from "./StatsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsBlock.vue?vue&type=script&setup=true&lang=js"

import "./StatsBlock.vue?vue&type=style&index=0&id=f6302844&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6302844"]])

export default __exports__